var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_vm._v(" "+_vm._s(_vm.title || "กรอกข้อมูลเพื่อรับของรางวัล")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }